import React from 'react';
import { useOutletContext } from 'react-router-dom';

import {
  inputAcceptTransmitDataConfig,
  inputBirthcountryConfig,
  inputBirthdateConfig,
  inputBirthplaceConfig,
  inputEmailConfig,
  inputEmailValidConfig,
  inputFileUploadConfig,
  inputPhoneConfig,
  inputTextareaDescriptionConfig,
} from '../../../configs';
import { PageLayoutContext, SecurityFormValues } from '../../../interfaces';
import { personGroupDecorator } from '../../../libs/decorators';
import { FileInputLabel, FormName, FormType } from '../../../libs/enums';
import {
  CheckboxComponent,
  FileUploadComponent,
  TextAreaComponent,
  TextInputComponent,
} from '../../dsfr';
import { FormWrapperComponent } from '../form-wrapper';
import { PersonGroup } from '../person-group';

export const SecurityForm = React.memo(() => {
  const { errorId, platform } = useOutletContext<PageLayoutContext>();

  const memoizedDescription = React.useMemo(
    () => (
      <React.Fragment>
        Pour faciliter la prise en charge de votre demande, veuillez nous transmettre la capture
        d’écran de la page du compte que vous avez utilisé.
        <br />
        <br />
        Taille maximale : 2Mo. Les formats supportés sont : JPG, JPEG, PNG, GIF, DOCX, ODT, PDF.
      </React.Fragment>
    ),
    [],
  );

  return (
    <FormWrapperComponent<SecurityFormValues>
      decorators={[personGroupDecorator]}
      initialValues={{
        acceptTransmitData: false,
        birthcountry: undefined,
        birthdate: undefined,
        birthplace: undefined,
        email: undefined,
        emailValid: undefined,
        errorId,
        fileUpload: undefined,
        firstName: undefined,
        firstNameDisabled: false,
        formName: FormName.SECURITY,
        formType: FormType.SECURITY,
        lastName: undefined,
        lastNameDisabled: false,
        phone: undefined,
        platform,
        textareaDescription: undefined,
      }}>
      <React.Fragment>
        <PersonGroup />
        <TextInputComponent {...inputBirthdateConfig} />
        <TextInputComponent {...inputBirthcountryConfig} />
        <TextInputComponent {...inputBirthplaceConfig} />
        <TextInputComponent {...inputEmailConfig} />
        <TextInputComponent {...inputEmailValidConfig} />
        <TextInputComponent {...inputPhoneConfig} />
        <TextAreaComponent {...inputTextareaDescriptionConfig} />
        <FileUploadComponent
          {...inputFileUploadConfig}
          description={memoizedDescription}
          label={FileInputLabel.SCREEN}
          required={false}
        />
        <CheckboxComponent {...inputAcceptTransmitDataConfig} />
      </React.Fragment>
    </FormWrapperComponent>
  );
});

SecurityForm.displayName = 'SecurityForm';
